import { isValid, isWithinInterval, parseISO } from 'date-fns';
import type { HTTPError } from 'ky';

import type { ToastMessage } from '~/components/Toast';
import { HttpStatusCode } from '~settings/api/lib/types';

export const getErrorMessage = (error: HTTPError): ToastMessage => {
  const status = error?.response?.status as HttpStatusCode;

  switch (status) {
    case HttpStatusCode.EntityConflict: {
      return {
        title: 'sublabelRequest.errors.entityConflict.title',
        description: 'sublabelRequest.errors.entityConflict.message',
      };
    }
    case HttpStatusCode.BadRequest: {
      return {
        title: 'sublabelRequest.errors.validation.title',
        description: 'sublabelRequest.errors.validation.message',
      };
    }
    default:
      return {
        title: 'sublabelRequest.errors.generic.title',
        description: 'sublabelRequest.errors.generic.message',
      };
  }
};

export const isValidDateInsideTimeframe = (
  input: unknown,
  from: string | Date,
  to: string | Date = new Date(),
) => {
  const num = Number(input);

  if (isNaN(num) || num <= 0) {
    return false;
  }

  const date = new Date(num);

  if (!isValid(date)) {
    return false;
  }

  const fromDate = typeof from === 'string' ? parseISO(from) : from;
  const toDate = typeof to === 'string' ? parseISO(to) : to;

  try {
    return isWithinInterval(date, {
      start: fromDate,
      end: toDate,
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
};
